import FormData from 'form-data';

// use this function to construct form data for upload image when creating or updating item, ingredient, business, or staff employee
// when namespace is item, then id is itemId.
// namespace: item, ingredient, business, user
// id: itemId, ingredientId, businessId, userId
export function constructFormData(image, namespace, id) {
  const formData = new FormData();
  formData.append('file', image);
  formData.append('namespace', namespace);
  formData.append('id', id);
  return formData;
}

// use this function for upload image when creating item or ingredient to all outlets
export function constructFormDataWithoutId(image, namespace) {
  const formData = new FormData();
  formData.append('file', image);
  formData.append('namespace', namespace);
  return formData;
}
